import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class FileTooBigFail extends UploadFail {
    static WEB_BACKEND_ERROR = 'file_too_big';

    radarName = 'fail_{SOURCE}_file_too_big';
    message = ['Загрузка невозможна. У владельца этой папки недостаточно места в Облаке для ваших файлов.'].join(' ');
}
